<template>
    <div class="sub-title">
        <div class="flex-box nopadding f15">
            <Icon class="mg-right3" :class="icon_class" type="ios-radio-button-on" /><slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "mySubTitle",
        props:{
            icon_class:{
                type: String,
                default: 'f-blue'
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/mySubTitle.vue